import { combineReducers } from 'redux';
import {
  clientConfig,
  ConfigState,
  adminConfig,
  AdminConfigState,
} from '@src/app/main/reducers';
import { reducer as form, FormState } from 'redux-form';
import { reducer as auth, AuthState } from '@src/app/login/reducers';
import { reducer as intellisel, State as IntelliselState } from '@src/app/intellisel/reducer';
import {
  reducer as account,
  State as AccountState,
} from '@src/app/accounts/redux/reducers';
import { reducer as notifications } from 'react-notification-system-redux';
import {
  reducer as userState,
  UserState,
} from '@src/app/user/reducers';

interface StoreEnhancerState {}

export interface RootState extends StoreEnhancerState {
  clientConfig: ConfigState;
  adminConfig: AdminConfigState;
  form: FormState;
  account: AccountState;
  auth: AuthState;
  intellisel: IntelliselState;
  notifications: any;
  userState: UserState;
}

export const appReducer = combineReducers<RootState, any>({
  auth,
  clientConfig,
  adminConfig,
  form,
  account,
  intellisel,
  notifications,
  userState
});

export const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = {
      clientConfig: state.clientConfig,
      adminConfig: state.adminConfig,
    };
  }
  return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_redux/root-reducer.ts